import { GeometryContext } from '@/context/geometry';
import { useContext } from 'react';

export const useGeometry = () => {
  return useContext(GeometryContext);
};
